import { all } from '@redux-saga/core/effects';
import actividadModule from './actividad/actividadModule';
import deleteActividadModule from './actividad/deleteActividadModule';
import listActividadModule from './actividad/listActividadModule';
import postActividadModule from './actividad/postActividadModule';
import updateActividadModule from './actividad/updateActividadModule';
import getAlertsModule from './alerts/alertsModule';
import deleteAlertsModule from './alerts/deleteAlertsModule';
import newAlertsModule from './alerts/newAlertsModule';
import readAlertsModule from './alerts/readAlertsModule';
import alertsSagas from './alerts/sagas';
import authSagas from './auth/sagas';
import downloadCertificadoModule from './certificado/downloadCertificadoModule';
import listComunicacionModule from './comunicacion/ListComunicacionModule';
import registerComunicacionModule from './comunicacion/RegisterComunicacionModule';
import deleteDonacionModule from './donaciones/deleteDonacionModule';
import listDonacionesModule from './donaciones/lisDonacionesModule';
import registerDonacionSagas from './donaciones/sagas';
import donacionExternaModule from './donacionExterna/donacionExternaModule';
import listDonacionesOwnModule from './donacionOwn/listDonacionesOwnModule';
import deleteEntidadModule from './entidades/deleteEntidadModule';
import entidadModule from './entidades/entidadModule';
import listEntidadModule from './entidades/listEntidadModule';
import registerEntidadModule from './entidades/registerEntidadModule';
import setPrincipalEntidadModule from './entidades/setPrincipalEntidadModule';
import updateEntidadModule from './entidades/updateEntidadModule';
import externalDonatorModule from './externalDonators/externalDonatorModule';
import facturacionModule from './facturacion/facturacionModule';
import changePasswordModule from './forgotPassword/changePasswordModule';
import sendPasswordModule from './forgotPassword/sendPasswordModule';
import kpisModule from './kpis/kpisModule';
import poblacionSagas from './poblacion/sagas';
import deleteOrganizacionModule from './organizaciones/deleteOrganizacionModule';
import listOrganizacionModule from './organizaciones/listOrganizacionModule';
import organizacionModule from './organizaciones/organizacionModule';
import registerOrganizacionModule from './organizaciones/registerOrganizacionModule';
import updateOrganizacionModule from './organizaciones/updateOrganizacionModule';
import editOrganizacionModule from './organizaciones/editOrganizacionModule';
import listSesionModule from './sesion/listSesionModule';
import registerSesionModule from './sesion/registerSesionModule';
import changeEstadoSolicitudModule from './solicitud/changeEstadoSolicitudModule';
import listSolicitudModule from './solicitud/listSolicitudModule';
import registerSolicitudModule from './solicitud/registerSolicitudModule';
import sendSolicitudModule from './solicitud/sendSolicitudModule';
import solicitudModule from './solicitud/solicitudModule';
import checkoutSessionSagas from './stripe/checkoutSession/sagas';
import listPaymentMethodsModule from './stripe/customer/listPaymentMethods';
import customerSliceSagas from './stripe/customer/sagas';
import paymentMethodSagas from './stripe/paymentMethod/sagas';
import productsModule from './stripe/products/productsModule';
import setupIntentSagas from './stripe/setupIntent/sagas';
import deleteUserModule from './users/deleteUserModule';
import exportUserModule from './users/exportUserModule';
import listUserModule from './users/listUserModule';
import registerUserModule from './users/registerUserModule';
import updateUserModule from './users/updateUserModule';
import userModule from './users/userModule';
import bajaMiembroModule from './users/miembros/bajaMiembroModule';
import bajaMiembroRestrictionsModule from './users/miembros/bajaMiembroRestrictionsModule';
import registerMiembroSagas from './users/miembros/sagas';
import getValoracionModule from './valoraciones/getValoracionModule';
import registerValoracionModule from './valoraciones/registerValoracionModule';
import updateValoracionModule from './valoraciones/updateValoracionModule';
import changeOrganizacionModule from './miembros/changeOrganizacionModule';
import deleteMiembroModule from './miembros/deleteMiembroModule';
import deleteMiembroSocioModule from './miembros/deleteMiembroSocioModule';
import exportMiembrosModule from './miembros/exportMiembrosModule';
import getMiembroSocioModule from './miembros/getMiembroSocioModule';
import listMiembroModule from './miembros/listMiembrosModule';
import miembroSagas from './miembros/sagas';
import updateMiembroModule from './miembros/updateMiembroModule';
import updateDatosPersonalesModule from './perfil/updateDatosPersonalesModule';
import deleteVoluntarioModule from './voluntarios/deleteVoluntarioModule';
import listVoluntariosModule from './voluntarios/ListVoluntariosModule';
import listVoluntariosBySolicitudModule from './solicitud/ListVoluntariosBySolicitudModule';
import voluntarioBajaModule from './voluntarios/voluntarioBajaModule';
import voluntarioEstadoModule from './voluntarios/voluntarioEstadoModule';
import voluntarioDisponibilidadModule from './voluntarios/voluntarioDisponibilidadModule';
import updateVoluntarioDisponibilidadModule from './voluntarios/updateVoluntarioDisponibilidadModule';
import uploadVoluntarioAcuerdoModule from './voluntarios/uploadVoluntarioAcuerdoModule';
import perfilVoluntarioModule from './voluntarios/perfilVoluntarioModule';
import postPerfilVoluntarioModule from './voluntarios/postPerfilVoluntarioModule';
import showVoluntarioModule from './voluntarios/showVoluntarioModule';
import cancelAssociateSubscriptionModule from './miembros/cancelAssociateSubscription';
import voluntarioAcuerdoModule from './voluntarios/voluntarioAcuerdoModule';
import updateVoluntarioAcuerdoModule from './voluntarios/updateVoluntarioAcuerdoModule';
import listRecursoModule from './recursos/listRecursoModule';
import uploadRecursoModule from './recursos/uploadRecursoModule';
import downloadRecursoModule from './recursos/downloadRecursoModule';
import deleteRecursoModule from './recursos/deleteRecursoModule';

export default function* rootSaga() {
  yield all([
    ...authSagas,
    ...registerUserModule.sagas,
    ...listUserModule.sagas,
    ...getAlertsModule.sagas,
    ...readAlertsModule.sagas,
    ...alertsSagas,
    ...newAlertsModule.sagas,
    ...registerOrganizacionModule.sagas,
    ...poblacionSagas,
    ...listOrganizacionModule.sagas,
    ...organizacionModule.sagas,
    ...updateOrganizacionModule.sagas,
    ...editOrganizacionModule.sagas,
    ...deleteOrganizacionModule.sagas,
    ...externalDonatorModule.sagas,
    ...checkoutSessionSagas,
    ...donacionExternaModule.sagas,
    ...sendPasswordModule.sagas,
    ...changePasswordModule.sagas,
    ...registerEntidadModule.sagas,
    ...listEntidadModule.sagas,
    ...deleteEntidadModule.sagas,
    ...entidadModule.sagas,
    ...updateEntidadModule.sagas,
    ...setPrincipalEntidadModule.sagas,
    ...exportUserModule.sagas,
    ...registerMiembroSagas,
    ...productsModule.sagas,
    ...deleteUserModule.sagas,
    ...listDonacionesModule.sagas,
    ...listMiembroModule.sagas,
    ...exportMiembrosModule.sagas,
    ...updateUserModule.sagas,
    ...userModule.sagas,
    ...listPaymentMethodsModule.sagas,
    ...setupIntentSagas,
    ...paymentMethodSagas,
    ...customerSliceSagas,
    ...deleteDonacionModule.sagas,
    ...registerDonacionSagas,
    ...deleteMiembroModule.sagas,
    ...updateMiembroModule.sagas,
    ...updateDatosPersonalesModule.sagas,
    ...facturacionModule.sagas,
    ...changeOrganizacionModule.sagas,
    ...getMiembroSocioModule.sagas,
    ...miembroSagas,
    ...deleteMiembroSocioModule.sagas,
    ...listDonacionesOwnModule.sagas,
    ...listSolicitudModule.sagas,
    ...registerSolicitudModule.sagas,
    ...downloadCertificadoModule.sagas,
    ...sendSolicitudModule.sagas,
    ...solicitudModule.sagas,
    ...listVoluntariosModule.sagas,
    ...listVoluntariosBySolicitudModule.sagas,
    ...changeEstadoSolicitudModule.sagas,
    ...registerValoracionModule.sagas,
    ...getValoracionModule.sagas,
    ...bajaMiembroRestrictionsModule.sagas,
    ...bajaMiembroModule.sagas,
    ...updateValoracionModule.sagas,
    ...registerSesionModule.sagas,
    ...listSesionModule.sagas,
    ...voluntarioEstadoModule.sagas,
    ...voluntarioDisponibilidadModule.sagas,
    ...updateVoluntarioDisponibilidadModule.sagas,
    ...voluntarioAcuerdoModule.sagas,
    ...uploadVoluntarioAcuerdoModule.sagas,
    ...perfilVoluntarioModule.sagas,
    ...postPerfilVoluntarioModule.sagas,
    ...voluntarioBajaModule.sagas,
    ...registerComunicacionModule.sagas,
    ...listComunicacionModule.sagas,
    ...deleteAlertsModule.sagas,
    ...postActividadModule.sagas,
    ...listActividadModule.sagas,
    ...deleteActividadModule.sagas,
    ...actividadModule.sagas,
    ...updateActividadModule.sagas,
    ...deleteVoluntarioModule.sagas,
    ...kpisModule.sagas,
    ...showVoluntarioModule.sagas,
    ...cancelAssociateSubscriptionModule.sagas,
    ...voluntarioAcuerdoModule.sagas,
    ...updateVoluntarioAcuerdoModule.sagas,
    ...listRecursoModule.sagas,
    ...uploadRecursoModule.sagas,
    ...downloadRecursoModule.sagas,
    ...deleteRecursoModule.sagas,
  ]);
}
